const isRequired = value => {
  if (typeof value === 'string') {
    const str = '' + value
    if (!value.length) {
      return 'validation_error.required'
    }
  } else {
    if (!value) return 'validation_error.required'
  }
}

export default isRequired
